module.exports = __webpack_public_path__ + "assets/img/HealthcareSolutions-xiaohua.41869a6f.png";